import React from "react";
import {CardBody, CardText, CardTitle, Row} from "reactstrap";

export const JobsCard = ({data}) => {
  const {task_name, status, date_created} = data;
  return (
    <Row>
      <div className="col-12 mt-3">
        <div style={{display: "flex", flex: "1 1 auto"}}>
          <CardBody>
            <CardTitle tag="h3">
              <CardText>Task Name : {task_name} </CardText>
            </CardTitle>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Status : {status}
            </CardText>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Date Created : {date_created}
            </CardText>
          </CardBody>
        </div>
      </div>
    </Row>
  );
};
